enum KioskStatus {
  Active = "ACTIVE",
  Disabled = "DISABLED",
}

export default KioskStatus;
